import { ModuleWithProviders, NgModule } from '@angular/core';
import { LinkedinInsightsService } from './shared/linkedin-insights.service';

export interface LinkedinInsightsConfiguration {
  enabled: boolean;
  linkedinId: string;
}

@NgModule({
  imports: [],
})
export class LinkedinInsightsModule {
  static forRoot(
    config: LinkedinInsightsConfiguration,
  ): ModuleWithProviders<LinkedinInsightsModule> {
    return {
      ngModule: LinkedinInsightsModule,
      providers: [
        LinkedinInsightsService,
        {
          provide: 'linkedinConfig',
          useValue: config,
        },
      ],
    };
  }
}
